var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerms({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.47 22C7.478 22 5.481 22 4.24 20.828C3 19.657 3 17.771 3 14V10C3 6.229 3 4.343 4.24 3.172C5.481 2 7.478 2 11.47 2H12.53C16.523 2 18.519 2 19.76 3.172C21 4.343 21 6.229 21 10M11.5 22H13M8 7H16M8 12H13",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 18.59L16.598 21.743C16.5889 21.7788 16.5899 21.8163 16.6008 21.8516C16.6118 21.8868 16.6322 21.9183 16.66 21.9426C16.6877 21.967 16.7216 21.9831 16.758 21.9894C16.7944 21.9956 16.8317 21.9917 16.866 21.978L18.851 21.185C18.9466 21.1466 19.0534 21.1466 19.149 21.185L21.153 21.985C21.1865 21.9984 21.2231 22.0024 21.2587 21.9967C21.2943 21.991 21.3278 21.9758 21.3555 21.9526C21.3831 21.9294 21.404 21.8992 21.4159 21.8651C21.4278 21.831 21.4303 21.7944 21.423 21.759L20.659 18.491M22 15.995C21.9987 15.2002 21.682 14.4384 21.1196 13.8769C20.5571 13.3154 19.7948 13 19 13C17.343 13 16 14.341 16 15.995C16.0003 16.3887 16.0781 16.7784 16.229 17.142C16.3799 17.5056 16.601 17.8358 16.8796 18.114C17.1582 18.3921 17.4888 18.6126 17.8526 18.7629C18.2165 18.9132 18.6063 18.9904 19 18.99C20.657 18.99 22 17.65 22 15.995Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerms);
export default __webpack_public_path__ + "static/media/terms.0322feae86051afc1574752ece971981.svg";
export { ForwardRef as ReactComponent };